const getQueryParamTenantId = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const tenantId = searchParams.get("tid");

  return tenantId;
};

export default getQueryParamTenantId;
